/**
 */

import { put, takeEvery, select } from "redux-saga/effects";
import { ActionType } from "typesafe-actions";
import dateFormat from "date-fns/format";
import Cookies from "js-cookie";
import { DateFormats } from "@utils/date";
import {
  analyticsMapping,
  getUtmParams,
  sanitizeProperties
  // waitTrackerResolve
} from "./helpers";
import * as actions from "./actions";
import { trackAPI, viewAPI } from "./api";
import ActionTypes from "./constants";
import { getJourneyType } from "@components/car/journey/common/utils";
import { journeyEnum } from "@utils/journeyEnum";
import isNewCar from "@utils/isNewCar";
import { isEmpty } from "@utils/lodash";
import { getFromSessionStorage } from "@utils/handleSessionStorage";
import { getNcb } from "@utils/formatters";
const { track } = actions;

const selector = store => store.proposalDataReducer;
// const indexSelector = store => store.indexReducer;
const planDetailsSelector = store => store.planDetailsReducer;
const plansSelector = store => store.plansPageReducer;
const valueToBooleanString = value => {
  return value && value === true ? "true" : "false";
};

function* trackSaga(action: ActionType<typeof actions>) {
  const proposalData = yield select(selector);
  // const indexData = yield select(indexSelector);
  const plansData = yield select(plansSelector);
  const planDetailsData = yield select(planDetailsSelector);

  let planTypeData: any = {};

  let filteredData = {
    ...Object?.entries(analyticsMapping).reduce((a, [k, v]) => {
      if (v === "pped_autofill") {
        return {
          ...a,
          [v]:
            proposalData.data?.previous_policy_expiry_date &&
            proposalData.data?.ppedSource !== "user" &&
            proposalData.data?.ppedSource !== "advisor"
              ? true
              : false
        };
      }
      if (v === "od_expiry_date_autofill") {
        return {
          ...a,
          [v]:
            proposalData.data?.previous_policy_expiry_date &&
            proposalData.data?.check_od_only &&
            proposalData.data?.ppedSource !== "user" &&
            proposalData.data?.ppedSource !== "advisor"
              ? "true"
              : "false"
        };
      }
      if (v === "tp_expiry_date_autofill") {
        return {
          ...a,
          [v]:
            proposalData.data?.third_party_pped &&
            proposalData.data?.ppedSource !== "user" &&
            proposalData.data?.ppedSource !== "advisor"
              ? "true"
              : "false"
        };
      }
      if (v === "addon_selected") {
        const addonsList = proposalData.data["selectedAddons"]?.map(adon => {
          return adon.id;
        });
        return {
          ...a,
          [v]: addonsList
        };
      }
      if (v === "addon_selected_count") {
        return {
          ...a,
          [v]: proposalData.data["selectedAddons"]?.length
        };
      }
      if (v === "communication_pincode") {
        const value =
          proposalData.data[k]?.toString() ||
          proposalData?.data["suggested_pincode"]?.toString();
        return {
          ...a,
          [v]: value
        };
      }
      if (v === "is_external_cng") {
        const value = proposalData?.data["externalCNGKit"];
        return {
          ...a,
          [v]: value && value === "1" ? true : false
        };
      }
      if (v === "is_commercial") {
        const value =
          proposalData.data[k] || proposalData?.data["suggested_is_commercial"];
        return {
          ...a,
          [v]: value && value === "1" ? true : false
        };
      }
      if (v === "mobile_verified") {
        return {
          ...a,
          [v]: !!proposalData.data["mobileVerified"]
        };
      }
      if (v === "advisor_shared") {
        return {
          ...a,
          [v]: valueToBooleanString(proposalData.data["advisorShared"])
        };
      }
      if (v === "cc") {
        return {
          ...a,
          [v]: proposalData.data["cc"] && proposalData.data["cc"].toString()
        };
      }
      if (v === "mmv_autofill") {
        return {
          ...a,
          [v]: valueToBooleanString(proposalData.data["rcDataPopulated"])
        };
      }
      if (v === "ncb_claims_autofill") {
        return {
          ...a,
          [v]: !!proposalData.data["iibLastClaimYear"]
        };
      }
      if (v === "selected_idv") {
        return {
          ...a,
          [v]: proposalData.data["idv"] && proposalData.data["idv"].toString()
        };
      }
      if (v === "registration_month") {
        return {
          ...a,
          [v]: proposalData.data["registrationMonth"]?.toString()
        };
      }
      if (v === "new_ncb") {
        return {
          ...a,
          [v]: proposalData.data[k] && proposalData.data[k]?.replace("%", "")
        };
      }

      if (v === "leadsource") {
        return {
          ...a,
          [v]: proposalData.data[k] === "ackodrive"
        };
      }

      if (v === "electrical_accessories_type_selected") {
        let accessoriesAddon = null;
        proposalData.data["selectedAddons"]?.map(adon => {
          if (adon?.id === "electrical_accessories_own_damage_basic_car") {
            accessoriesAddon = adon?.assured_accessories?.map(
              accs => accs.name
            );
          }
        });
        return {
          ...a,
          [v]: accessoriesAddon
        };
      }

      if (v === "non_electrical_accessories_type_selected") {
        let accessoriesAddon = null;
        proposalData.data["selectedAddons"]?.map(adon => {
          if (adon?.id === "non_electrical_accessories_own_damage_basic_car") {
            accessoriesAddon = adon?.assured_accessories?.map(
              accs => accs.name
            );
          }
        });
        return {
          ...a,
          [v]: accessoriesAddon
        };
      }

      if (v === "electrical_accessories_value_entered") {
        let accessoriesAddonValue = null;
        proposalData.data["selectedAddons"]?.map(adon => {
          if (adon?.id === "electrical_accessories_own_damage_basic_car") {
            accessoriesAddonValue = adon?.sum_assured_value;
          }
        });
        return {
          ...a,
          [v]: accessoriesAddonValue
        };
      }

      if (v === "non_electrical_accessories_value_entered") {
        let accessoriesAddonValue = null;
        proposalData.data["selectedAddons"]?.map(adon => {
          if (adon?.id === "non_electrical_accessories_own_damage_basic_car") {
            accessoriesAddonValue = adon?.sum_assured_value;
          }
        });
        return {
          ...a,
          [v]: accessoriesAddonValue
        };
      }

      if (v === "eligible_for_previous_plan") {
        const previousPlanId = proposalData?.data?.previousPolicyType;

        const eligiblePlan =
          plansData?.plans?.filter(plan => plan?.id?.includes(previousPlanId))
            ?.length > 0;
        return {
          ...a,
          [v]: eligiblePlan
        };
      }
      // Confused with Naming refer this ticket: https://ackotech.atlassian.net/browse/ABN-5767
      if (v === "dis_fac") {
        const formattedDisFac = JSON.parse(proposalData?.data?.[k]);
        const dis_fac = {};
        formattedDisFac &&
          formattedDisFac?.forEach(data => {
            if (data?.pid?.includes("zero_dep")) {
              dis_fac[`${data?.pid}_zd_d`] = data?.d;
            } else {
              dis_fac[`${data?.pid}_od_d`] = data?.d;
            }
          });
        return {
          ...a,
          ...(dis_fac || {})
        };
      }

      if (v === "is_id_beaten") {
        const formattedData = JSON.parse(proposalData.data?.[k]);
        const isIdBeaten = {};

        try {
          if (formattedData !== null) {
            for (const [key, value] of Object.entries(formattedData)) {
              // @ts-ignore
              const [_, id, ...rest] = key.split("_");
              isIdBeaten[`${id}_b`] = value;
            }
          }
        } catch (error) {
          console.log(
            error,
            "in Segment data saga: is_id_beaten data formulation "
          );
        }
        return {
          ...a,
          ...(isIdBeaten || {})
        };
      }

      if (v === "pricingSegmentData") {
        return {
          ...a,
          // Spreading pricing segment data as we don't specify individual keys in analytics mapping (helper.ts)
          ...(proposalData?.data?.[k] || {})
        };
      }
      if (v === "previous_policy_status") {
        return {
          ...a,
          [v]: !!proposalData?.data?.[k]
            ? proposalData?.data?.[k]
            : "Not Expired"
        };
      }

      if (v === "previous_addons_count") {
        return {
          ...a,
          [v]: proposalData.data["prevoiusYearAddon"]?.length
        };
      }

      if (v === "previous_addons_selected") {
        const previousAddonsList = proposalData.data[k]?.map(adon => adon?.id);
        return {
          ...a,
          [v]: previousAddonsList
        };
      }

      if (v === "lastyear_renewal_premium_delta") {
        let premiumDelta;
        // logic as current - previous
        try {
          premiumDelta =
            Number(planDetailsData?.data?.plan?.price?.net_premium) -
            Number(proposalData?.data?.["previousPolicyNetPremium"]);
          if (Number.isNaN(premiumDelta)) throw "Invalid Calculation";
        } catch (error) {
          premiumDelta = null;
        }
        return {
          ...a,
          [v]: premiumDelta
        };
      }

      if (v === "lastyear_renewal_ncb_delta") {
        // logic as current - previous
        return {
          ...a,
          [v]:
            getNcb(proposalData.data["ncb"])?.value -
            getNcb(proposalData.data["previous_ncb"])?.value
        };
      }

      if (v === "lastyear_renewal_idv_delta") {
        // logic as current - previous
        const renewalIdvDelta =
          proposalData.data?.["idv"] && proposalData.data?.["previous_idv"]
            ? proposalData.data?.["idv"] - proposalData.data?.["previous_idv"]
            : null;
        return {
          ...a,
          [v]: renewalIdvDelta
        };
      }

      if (v === "previous_plan") {
        const previousPlan =
          proposalData.data?.previous_policy_type ||
          proposalData.data?.previousPolicyType;

        return {
          ...a,
          [v]: previousPlan
        };
      }
      if (v === "dec") {
        return {
          ...a,
          ["decile_from_ir"]: Number(proposalData?.data?.["dec"]),
          ["dec"]: proposalData?.data?.["dec"]
        };
      }
      if (v === "is_eligible_for_calling") {
        const isOnlyTpPlanOffered =
          plansData?.plans?.length === 1 &&
          plansData?.plans?.[0]?.id === "car_tp";
        const isPrevPlanNonTp =
          proposalData?.data?.previousPolicyType &&
          proposalData?.data?.previousPolicyType !== "third_party";

        return {
          ...a,
          [v]: !(isOnlyTpPlanOffered && isPrevPlanNonTp)
        };
      }
      return {
        ...a,
        [v]: proposalData?.data?.[k]
      };
    }, {})
  };

  const { isViewEvent = false } = action.payload.customAttributes;
  delete action.payload.customAttributes?.isViewEvent;
  const actionData = action.payload.customAttributes;
  const {
    expiry,
    policyStatus,
    previous_policy_expiry_date,
    previous_policy_expiry_date_min,
    previous_policy_expiry_date_max,
    own_damage_pped,
    third_party_pped
  } = proposalData?.data;
  const previousPolicyExpired = expiry
    ? {
        previous_policy_expired: expiry ? expiry : null
      }
    : {};

  const ppedData =
    expiry === "0" && policyStatus
      ? {
          previous_policy_expiry_date: previous_policy_expiry_date
            ? `${previous_policy_expiry_date.substring(0, 10)}T18:29:59.999Z`
            : null,
          previous_policy_expiry_date_min: previous_policy_expiry_date_min
            ? `${previous_policy_expiry_date_min.substring(
                0,
                10
              )}T18:29:59.999Z`
            : null,
          previous_policy_expiry_date_max: previous_policy_expiry_date_max
            ? `${previous_policy_expiry_date_max.substring(
                0,
                10
              )}T18:29:59.999Z`
            : null
        }
      : {};

  const odData =
    own_damage_pped && third_party_pped
      ? {
          own_damage_pped: `${dateFormat(
            new Date(own_damage_pped),
            DateFormats.ISO_DATE
          )}T18:29:59.999Z`,
          third_party_pped: `${dateFormat(
            new Date(third_party_pped),
            DateFormats.ISO_DATE
          )}T18:29:59.999Z`,
          previous_policy_expiry_date_min: previous_policy_expiry_date_min
            ? `${previous_policy_expiry_date_min.substring(
                0,
                10
              )}T18:29:59.999Z`
            : null,
          previous_policy_expiry_date_max: previous_policy_expiry_date_max
            ? `${previous_policy_expiry_date_max.substring(
                0,
                10
              )}T18:29:59.999Z`
            : null
        }
      : {};

  const androidData =
    Cookies.get("webview") === "android_app"
      ? {
          android: true,
          android_app_version: Cookies.get("android_app_version")
        }
      : {};

  /* *  Five Plan comprehensive renaming massaging * */

  if (action.payload.edata) {
    switch (action.payload.edata.plan_type) {
      case "fiveplan_car_comprehensive":
        // eslint-disable-next-line no-param-reassign
        action.payload.edata.plan_type = "car_comprehensive";
        break;
      case "fiveplan_zero_dep":
        // eslint-disable-next-line no-param-reassign
        action.payload.edata.plan_type = "zero_dep";
        break;
      default:
        break;
    }
  }

  if (planTypeData) {
    switch (planTypeData.plan_type) {
      case "fiveplan_car_comprehensive":
        planTypeData.plan_type = "car_comprehensive";
        break;
      case "fiveplan_zero_dep":
        planTypeData.plan_type = "zero_dep";
        break;
      default:
        break;
    }
  }

  /* *  * */

  const verifyOtpData = action.payload.ekind === "verify_otp_clicked" ? {} : {};

  const journeyType = getJourneyType("analytics");

  let idvDelta;
  try {
    // logic as updated idv - recommended idv
    if (!isEmpty(plansData)) {
      idvDelta = plansData?.idv?.selected - plansData?.idv?.recommended;
    } else if (!isEmpty(planDetailsData)) {
      idvDelta =
        planDetailsData?.data?.idv?.selected -
        planDetailsData?.data?.idv?.recommended;
    }
    if (Number.isNaN(idvDelta)) throw "Invalid Calculaion";
  } catch (error) {
    idvDelta = null;
  }

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const isAgentPortalFlow =
      (urlParams.get("lsi_portal_flow") || "") === "true";

    yield put(track.request());

    const payload = {
      event_name: action.payload.event_name,
      customAttributes: {
        ...getUtmParams(),
        landing_page: `${window.origin}${window.basePath}`,
        path: window.location.href,
        // journey has Value - buy fresh car, buy new car, buy fresh bike, buy new bike, buy renewal car, buy renewal bike
        journey: journeyEnum[window.product],
        product: "auto",
        // page: pagePath,
        platform: window.platform,
        idv_delta: idvDelta,
        // skip proposal data if its partner widget
        ...(!actionData.partner_widget && {
          ...(!isNewCar() && {
            prequote_version: journeyType === "v0" ? "old" : journeyType
          }),
          ncb_claims_autofill_updated: getFromSessionStorage(
            "ncbAutofillUpdated"
          )
            ? true
            : false,
          // TODO: get autofill source from backend rather then assuming based on prequote flow
          reg_year_month_autofill: journeyType !== "v0" ? "true" : "false"
        }),
        ...(!isEmpty(plansData) && {
          recommended_idv: plansData?.idv?.recommended
        }),
        ...verifyOtpData,
        ...ppedData,
        ...planTypeData,
        ...action.payload.edata,
        ...odData,
        ...previousPolicyExpired,
        ...androidData,
        // skip proposal data if its partner widget
        ...(!actionData.partner_widget && filteredData),
        // ...proposalData
        // This check pertains to the recommended insured declared value (IDV) for a new car,
        // specifically from the plans page up to the review screen.
        ...(!isEmpty(planDetailsData) && {
          recommended_idv: planDetailsData?.data?.idv?.recommended,
          premium_with_gst: planDetailsData?.data?.plan?.price?.gross_premium?.toString()
        }),
        ...((window.product === "freshBike" || window.product === "newBike") &&
          isAgentPortalFlow && {
            is_advisor_portal_flow: true
          }),
        proposal_id: proposalData?.proposalId,
        ...actionData,
        from_page: getFromSessionStorage("lastPage"),
        tracker_id: Cookies.get("trackerid") || ""
      }
    };
    // yield waitTrackerResolve();
    // TODO: Configure event type in the event action itself and remove string match logic
    const segmentAPI =
      action?.payload?.event_name?.toUpperCase()?.includes("VIEW_PAGE") ||
      isViewEvent
        ? viewAPI
        : trackAPI;
    // console.log(
    //   "^^^^^ segment payload",
    //   "-----",
    //   action.payload.event_name,
    //   plansData,
    //   "-----",
    //   payload
    // );
    yield segmentAPI({
      ...payload,
      customAttributes: sanitizeProperties(payload.customAttributes)
    });
    yield put(track.success(payload));
  } catch (e) {
    yield put(track.failure(e));
    const error = new Error("Segment saga error");
    window?.newrelic.noticeError(error, {
      name: `${action?.payload?.event_name}`
    });
  } finally {
    yield put(track.fulfill());
  }
}

/**
 * Root saga manages watcher life cycle
 */
export default function* analyticsSaga() {
  yield takeEvery(track.TRIGGER, trackSaga);
  yield takeEvery(ActionTypes.TRACK, trackSaga);
}
